import styled, { css } from 'styled-components';


export const BannerWrapper = styled.div`
  width: 100%;
  background: linear-gradient(
    90deg,
    #2ee9a9 0%,
    #038df2 100%
  );
`;

export const Container = styled.div`
  ${({ theme }) => css`
    box-sizing: border-box;
    display: flex;
    gap: 24px;
    margin: 0 auto;
    max-width: 1260px;
    padding: 24px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 16px;
      padding: 16px;
    }
  `}
`;

export const Video = styled.video`
  ${({ theme }) => css`
    border-radius: 12px;
    height: 350px;
    max-height: 350px;
    box-sizing: border-box;
    object-fit: cover;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const BannerContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    width: 50%;
    margin: auto 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    color: ${theme.v2.colors.neutral.highPure};
    margin: 0 0 16px;
    line-height: 150%;
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.md};
    }
    @media (max-width: ${theme.v2.breakpoints.xs}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.highPure};
    line-height: 150%;
    margin: 0 0 24px 0;
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
    @media (max-width: ${theme.v2.breakpoints.xs}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin-top: auto;
    gap: 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      gap: 16px;
      margin-bottom: 16px;
    }
  `}
`;

export const Option = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    padding: 24px;
    gap: 16px;
    border: 1px solid ${theme.v2.colors.brand.primaryLowLight};
    box-shadow: 0px 4px 6px 0px ${theme.v2.colors.brand.primaryLowLight};

    @media (min-width: ${theme.v2.breakpoints.md}) {
      flex: 1;
      max-width: 540px;
    }
  `}
`;

export const OptionHeader = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

export const OptionTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const OptionTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const OptionSubtitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const OptionDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 600px;
      width: 100%;
    }
  `}
`;

export const OptionButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 24px;
    margin-top: auto;
    padding-top: 8px;

    button {
      height: 48px;
      gap: 8px;

      svg {
        flex: 0 0 20px;
        height: 20px;
        width: 20px;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
    }
  `}
`;
